// extracted by mini-css-extract-plugin
export default {"container":"ml-z","blurb":"nl-z","links":"ol-z"};